import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { isPreviewBuild } from "@lib/preview";
import type { ReactNode } from "react";
import { AuthSplashScreen } from "./AuthSplashScreen";
import { PrivacyPolicy } from "./PrivacyPolicy";

type AuthGateProps = {
  children: ReactNode;
};

export function AuthGate({ children }: AuthGateProps) {
  const { isLoading, isAuthenticated } = useKindeAuth();

  if (import.meta.env.VITE_E2E === "true") {
    return children;
  }

  if (window.location.pathname === "/privacy") {
    return <PrivacyPolicy />;
  }

  if (isPreviewBuild()) {
    return children;
  }

  if (isLoading) {
    return <AuthSplashScreen showSignIn={false} />;
  }

  if (!isAuthenticated) {
    return <AuthSplashScreen showSignIn />;
  }

  return children;
}
